import React from "react";
import MobileAdminNavigation from "../components/common-components/mobile-admin-navigation";
import { useAppSelector } from "../redux/hooks";
import { useTranslation } from "react-i18next";
import useMediaQuery from "../utils/hooks/use-media-query";
import {Container, Row, Col} from "react-bootstrap";
import Sidebar from "../components/common-components/sidebar";
import { Toaster } from "react-hot-toast";
import '../styles/Dashboard.css';
import '../styles/admin-mobile.scss';

const AdminLayout = ({
  children
}: any) => {

  const user = useAppSelector(state => state.user.userData);
  const mobile = useMediaQuery("(max-width: 991.98px)");
  const { i18n } = useTranslation();
  const language = user?.preferred_language === 1 ? "he" : user?.preferred_language === 0 ? "en" : i18n.language;

  return (
    <>
      <Container fluid>
        <Row>
          <Col xs={2} id="sidebar-wrapper-admin">
            <MobileAdminNavigation role={user?.roles} language={language} />
            <Sidebar />
          </Col>
          <Col className="p-4 admin-page-content" xs={10} id="page-content-wrapper" dir={mobile ? (language === "he" ? "rtl" : "ltr") : undefined}>
            {children}
          </Col>
          <Toaster
            position="bottom-right"
            reverseOrder={false}
            toastOptions={{
              style: {
                backgroundColor: "#00B38F",
                color: "#fff",
              },
            }}
          />
        </Row>
      </Container>
    </>
  );
};
export default AdminLayout;
